// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaLDj92ncH8YhJUW{animation:W40iqRe4t14Qa1Bu 3s infinite;width:calc(100% - 16px);padding-left:8px;padding-right:8px}.h9zVNhCLeRkRy5fR{margin-top:8px}@keyframes W40iqRe4t14Qa1Bu{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.JT3YHmsnmqMB9a_q{overflow:hidden;white-space:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingCell": `SaLDj92ncH8YhJUW`,
	"placeHolderShimmer": `W40iqRe4t14Qa1Bu`,
	"truncatedTextButton": `h9zVNhCLeRkRy5fR`,
	"truncatedText": `JT3YHmsnmqMB9a_q`
};
export default ___CSS_LOADER_EXPORT___;
